var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 7a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 .75 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 7.5.25Z"
  }))));
};
export default SvgAdd;